// CookiePolicy.js
import React, { useState, useEffect, useRef } from 'react';
import './Pages/PagesCss/CookiePolicy.css';
import { useNavigate } from 'react-router-dom';

// ─── Icons ────────────────────────────────────────────────────────────────────
const Ic = {
  Cookie:   (p) => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" {...p}><circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.8"/><circle cx="9"  cy="10" r="1.2" fill="currentColor"/><circle cx="14" cy="8"  r="1.2" fill="currentColor"/><circle cx="15" cy="14" r="1.2" fill="currentColor"/><circle cx="10" cy="15" r="1.2" fill="currentColor"/><circle cx="12" cy="12" r="1"   fill="currentColor" opacity=".5"/></svg>,
  Shield:   (p) => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" {...p}><path d="M12 3L4 7V12C4 16.42 7.58 21 12 21C16.42 21 20 16.42 20 12V7L12 3Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round"/><path d="M9 12L11 14L15 10" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>,
  Lock:     (p) => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" {...p}><rect x="5" y="11" width="14" height="10" rx="2" stroke="currentColor" strokeWidth="1.8"/><path d="M8 11V8C8 5.79 9.79 4 12 4C14.21 4 16 5.79 16 8V11" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/><circle cx="12" cy="16" r="1.5" fill="currentColor"/></svg>,
  BarChart: (p) => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" {...p}><path d="M4 20V14M8 20V10M12 20V4M16 20V10M20 20V14" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/></svg>,
  Settings: (p) => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" {...p}><circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="1.8"/><path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 012.83-2.83l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 2.83l-.06.06A1.65 1.65 0 0019.4 9a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z" stroke="currentColor" strokeWidth="1.8"/></svg>,
  Globe:    (p) => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" {...p}><circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.8"/><path d="M12 3C12 3 8 7 8 12C8 17 12 21 12 21M12 3C12 3 16 7 16 12C16 17 12 21 12 21M3 12H21" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/></svg>,
  Mail:     (p) => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" {...p}><rect x="2" y="4" width="20" height="16" rx="2" stroke="currentColor" strokeWidth="1.8"/><path d="M2 8L12 14L22 8" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/></svg>,
  Update:   (p) => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" {...p}><path d="M4 12C4 7.58 7.58 4 12 4C14.67 4 17.04 5.27 18.54 7.25" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/><path d="M20 12C20 16.42 16.42 20 12 20C9.33 20 6.96 18.73 5.46 16.75" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/><path d="M16 7L18.54 7.25L20 5M8 17L5.46 16.75L4 19" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>,
  ChevronRight: (p) => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" {...p}><path d="M9 5L16 12L9 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>,
  ArrowUp:  (p) => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" {...p}><path d="M12 19V5M5 12L12 5L19 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>,
  Check:    (p) => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" {...p}><path d="M5 12L10 17L19 7" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/></svg>,
  X:        (p) => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" {...p}><path d="M5 5L19 19M19 5L5 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>,
  Info:     (p) => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" {...p}><circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.8"/><path d="M12 8V8.01M12 11V16" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>,
  Toggle:   (p) => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" {...p}><rect x="1" y="7" width="22" height="10" rx="5" stroke="currentColor" strokeWidth="1.8"/><circle cx="7" cy="12" r="3" fill="currentColor" opacity=".4"/></svg>,
};

// ─── Cookie data table ────────────────────────────────────────────────────────
const COOKIE_CATEGORIES = [
  {
    id: 'essential',
    label: 'Essential',
    color: '#10B981',
    canDisable: false,
    description: 'Required for the site to function. Cannot be disabled.',
    cookies: [
      { name: 'qp_session',    purpose: 'Keeps you logged in to your account across page loads', duration: 'Session', firstParty: true  },
      { name: 'qp_csrf',       purpose: 'Prevents cross-site request forgery (CSRF) attacks',    duration: 'Session', firstParty: true  },
      { name: 'qp_prefs',      purpose: 'Stores your UI preferences (e.g. theme, language)',     duration: '1 year',  firstParty: true  },
    ],
  },
  {
    id: 'analytics',
    label: 'Analytics',
    color: '#3B82F6',
    canDisable: true,
    description: 'Help us understand how the site is used so we can improve it.',
    cookies: [
      { name: '_plausible',     purpose: 'Privacy-first analytics no personal identifiers stored', duration: '1 year',  firstParty: true  },
      { name: 'ph_distinct_id', purpose: 'PostHog session ID used for aggregate product analytics only', duration: '1 year', firstParty: true },
    ],
  },
  {
    id: 'functional',
    label: 'Functional',
    color: '#8B5CF6',
    canDisable: true,
    description: 'Enable enhanced features like saved settings and tool preferences.',
    cookies: [
      { name: 'qp_recent_tools', purpose: 'Remembers your recently used tools for quick access',    duration: '90 days', firstParty: true  },
      { name: 'qp_plan_cache',   purpose: 'Caches your plan details to reduce server round-trips',  duration: '1 hour',  firstParty: true  },
    ],
  },
  {
    id: 'thirdparty',
    label: 'Third-party',
    color: '#F59E0B',
    canDisable: true,
    description: 'Set by our service providers for payment processing and support.',
    cookies: [
      { name: '__stripe_mid',    purpose: 'Stripe payment fraud prevention',  duration: '1 year',   firstParty: false },
      { name: '__stripe_sid',    purpose: 'Stripe session identifier',         duration: 'Session',  firstParty: false },
      { name: 'intercom-id-*',   purpose: 'Intercom support chat session',     duration: '9 months', firstParty: false },
    ],
  },
];

// ─── Sections ─────────────────────────────────────────────────────────────────
const SECTIONS = [
  {
    id: 'what',
    icon: Ic.Cookie,
    title: '1. What Are Cookies?',
    color: '#10B981',
    content: [
      {
        subtitle: 'A plain-English explanation',
        body: `Cookies are small text files that a website stores on your device (computer, phone, tablet) when you visit it. They are sent back to the website on subsequent visits so it can recognise you and remember your preferences.

Cookies serve many purposes: keeping you logged in, remembering your settings, understanding how people use the site, and making certain features work correctly. They cannot execute code or transmit viruses.

Beyond traditional cookies, websites may also use similar technologies such as local storage, session storage, and pixel tags. This Policy covers all such technologies collectively referred to as "cookies".`,
      },
    ],
  },
  {
    id: 'howweuse',
    icon: Ic.Settings,
    title: '2. How We Use Cookies',
    color: '#3B82F6',
    content: [
      {
        subtitle: 'Our approach',
        body: `QuickPDFs uses a minimal number of carefully chosen cookies. We do not use advertising cookies, cross-site tracking pixels, social media tracking buttons, or browser fingerprinting of any kind.

We group our cookies into four categories Essential, Analytics, Functional, and Third-party explained in detail in Section 3.

The Free plan (no account required) uses only Essential cookies and, if you have not opted out, anonymous analytics. Creating an account adds Functional cookies. Paying subscribers also interact with third-party payment cookies from Stripe.`,
      },
      {
        subtitle: 'What we never do',
        body: `We explicitly do not:

• Use advertising or retargeting cookies (e.g. Facebook Pixel, Google Ads)
• Track you across other websites
• Use browser fingerprinting as an alternative to cookies
• Share cookie data with data brokers or advertising networks
• Set cookies on behalf of third parties except our listed service providers`,
      },
    ],
  },
  {
    id: 'types',
    icon: Ic.BarChart,
    title: '3. Types of Cookies We Use',
    color: '#8B5CF6',
    isTable: true,
  },
  {
    id: 'managing',
    icon: Ic.Toggle,
    title: '4. Managing Your Cookie Preferences',
    color: '#F59E0B',
    content: [
      {
        subtitle: 'Via your browser',
        body: `All modern browsers allow you to view, block, and delete cookies. Here is how to access cookie settings in the most common browsers:

• Chrome: Settings → Privacy and security → Cookies and other site data
• Firefox: Settings → Privacy & Security → Cookies and Site Data
• Safari: Preferences → Privacy → Manage Website Data
• Edge: Settings → Cookies and site permissions → Cookies and site data

Note: Blocking essential cookies will prevent you from logging in to your account and may cause other features to stop working.`,
      },
      {
        subtitle: 'Via your account settings',
        body: `If you have a QuickPDFs account, you can manage your analytics and functional cookie preferences from Account Settings → Privacy. Changes take effect immediately and are remembered for your account across devices.`,
      },
      {
        subtitle: 'Opt-out of analytics',
        body: `We use Plausible Analytics, which is privacy-focused and does not use cookies by default. For users who have opted into enhanced analytics (PostHog), you can opt out at any time:

• From your account: Account Settings → Privacy → Analytics preferences
• Via browser: Install the Plausible opt-out browser extension, or enable "Do Not Track" in your browser (we honour DNT signals)
• By email: Contact us at privacy@quickpdfs.net and we will disable analytics for your account`,
      },
      {
        subtitle: 'Cookie consent banner',
        body: `On your first visit to QuickPDFs, you will see a cookie consent banner. This banner allows you to:

• Accept all cookies (including optional analytics and functional cookies)
• Accept essential cookies only (minimum required for the site to work)
• Customise your preferences by category

Your choice is saved in a cookie named qp_prefs and respected on all subsequent visits. You can change your preferences at any time by clicking "Cookie settings" in the footer.`,
      },
    ],
  },
  {
    id: 'thirdparty',
    icon: Ic.Globe,
    title: '5. Third-Party Cookies',
    color: '#EF4444',
    content: [
      {
        subtitle: 'Stripe (payment processing)',
        body: `When you make a payment or view your billing details, Stripe sets cookies to prevent payment fraud and maintain your payment session. These cookies are governed by Stripe's own privacy and cookie policies.

Stripe cookies used on QuickPDFs: __stripe_mid (1 year), __stripe_sid (session).

We have no access to, or control over, the data collected by Stripe's cookies beyond what is necessary to process your payment.`,
      },
      {
        subtitle: 'Plausible Analytics',
        body: `We use Plausible Analytics for privacy-respecting website analytics. Plausible does not use cookies by default and does not collect personal identifiers. All data is aggregated and anonymised.

If you have opted into enhanced analytics, Plausible may set a single first-party cookie. Plausible's data is stored on servers in the EU and is subject to GDPR. Learn more at plausible.io/privacy.`,
      },
      {
        subtitle: 'PostHog (product analytics opt-in only)',
        body: `For users who have opted in to enhanced analytics, we use PostHog to understand how features are used. PostHog sets a first-party cookie (ph_distinct_id) to distinguish sessions. No personal information is sent to PostHog only anonymised usage events.

You can opt out of PostHog analytics at any time from your account settings or by emailing privacy@quickpdfs.net.`,
      },
    ],
  },
  {
    id: 'gdpr',
    icon: Ic.Shield,
    title: '6. GDPR & Legal Basis',
    color: '#3B82F6',
    content: [
      {
        subtitle: 'Legal basis for cookie use',
        body: `If you are located in the European Union or European Economic Area, our use of cookies is governed by the General Data Protection Regulation (GDPR) and the ePrivacy Directive.

Our legal basis for each cookie category is:

Essential cookies Legitimate interests (necessary for the service to function and for security). These do not require consent.

Analytics cookies Consent. We will only set these if you explicitly agree via the cookie consent banner or your account settings.

Functional cookies Legitimate interests (improving user experience with preferences you set). You may opt out via your account settings.

Third-party cookies Consent for analytics; Contractual necessity for payment processing (Stripe).`,
      },
      {
        subtitle: 'Your GDPR rights regarding cookies',
        body: `Under GDPR, you have the right to:

• Withdraw consent for non-essential cookies at any time
• Request deletion of any personal data stored in cookies
• Object to processing based on legitimate interests
• Lodge a complaint with your local data protection authority

To exercise these rights, use your account settings or contact privacy@quickpdfs.net.`,
      },
    ],
  },
  {
    id: 'changes',
    icon: Ic.Update,
    title: '7. Changes to This Policy',
    color: '#64748B',
    content: [
      {
        subtitle: 'How we notify you',
        body: `We may update this Cookie Policy from time to time to reflect changes in the cookies we use or applicable law. When we make material changes, we will update the "Last updated" date at the top of this page and, for registered users, send an email notification.

We may also display a renewed cookie consent banner if we add new cookie categories or change the purpose of existing cookies significantly.

The current version of this Cookie Policy is always available at quickpdfs.net/cookie-policy.`,
      },
    ],
  },
  {
    id: 'contact',
    icon: Ic.Mail,
    title: '8. Contact Us',
    color: '#10B981',
    content: [
      {
        subtitle: 'Questions about cookies',
        body: `If you have questions about how we use cookies, want to report a concern, or wish to exercise your privacy rights, please contact us:

Privacy: privacy@quickpdfs.net
General support: support@quickpdfs.net
Company: D-Tech Studios
Website: quickpdfs.net

We aim to respond to all privacy-related enquiries within 5 business days.`,
      },
    ],
  },
];

// ─── Cookie table component ───────────────────────────────────────────────────
const CookieTable = () => {
  const [openCat, setOpenCat] = useState('essential');

  return (
    <div className="cp-cookie-table">
      {COOKIE_CATEGORIES.map(cat => (
        <div key={cat.id} className={`cp-cat-block${openCat === cat.id ? ' open' : ''}`}>
          {/* Category header — clickable accordion */}
          <button
            className="cp-cat-header"
            onClick={() => setOpenCat(openCat === cat.id ? null : cat.id)}
            style={{ '--cc': cat.color }}
          >
            <span className="cp-cat-dot" style={{ background: cat.color }} />
            <span className="cp-cat-name">{cat.label}</span>
            <span className="cp-cat-desc">{cat.description}</span>
            <span className={`cp-cat-badge ${cat.canDisable ? 'optional' : 'required'}`}>
              {cat.canDisable ? 'Optional' : 'Required'}
            </span>
            <span className="cp-cat-chevron">
              <Ic.ChevronRight />
            </span>
          </button>

          {/* Cookie rows */}
          {openCat === cat.id && (
            <div className="cp-cat-rows">
              <div className="cp-row-head">
                <span>Cookie name</span>
                <span>Purpose</span>
                <span>Duration</span>
                <span>First party</span>
              </div>
              {cat.cookies.map((c, i) => (
                <div key={i} className="cp-row">
                  <span className="cp-cookie-name">{c.name}</span>
                  <span className="cp-cookie-purpose">{c.purpose}</span>
                  <span className="cp-cookie-duration">{c.duration}</span>
                  <span className="cp-cookie-party">
                    {c.firstParty
                      ? <span className="cp-yes"><Ic.Check /> Yes</span>
                      : <span className="cp-no"><Ic.X /> No</span>
                    }
                  </span>
                </div>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

// ─── Main component ───────────────────────────────────────────────────────────
export default function CookiePolicy() {
  const navigate = useNavigate();
  const [activeSection, setActiveSection] = useState('what');
  const [showBackToTop, setShowBackToTop] = useState(false);
  const sectionRefs = useRef({});

  useEffect(() => {
    const handler = () => setShowBackToTop(window.scrollY > 400);
    window.addEventListener('scroll', handler);
    return () => window.removeEventListener('scroll', handler);
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) setActiveSection(entry.target.id);
        });
      },
      { rootMargin: '-20% 0px -70% 0px' }
    );
    Object.values(sectionRefs.current).forEach(ref => { if (ref) observer.observe(ref); });
    return () => observer.disconnect();
  }, []);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const LAST_UPDATED = 'March 18, 2026';

  return (
    <div className="cp-page">

      {/* ── Hero ──────────────────────────────────────────── */}
      <section className="cp-hero">
        <div className="cp-hero-bg" aria-hidden="true" />
        <div className="cp-container">

          <div className="cp-hero-badge">
            <span className="cp-badge-dot" />
            D-Tech Studios · QuickPDFs.net
          </div>

          <h1 className="cp-hero-title">Cookie Policy</h1>
          <p className="cp-hero-sub">
            We use a small, carefully chosen set of cookies to make QuickPDFs work.
            No advertising. No cross-site tracking. Here's exactly what we use and why.
          </p>

          <div className="cp-hero-meta">
            <span className="cp-meta-item">
              <Ic.Update /> Last updated: <strong>{LAST_UPDATED}</strong>
            </span>
            <span className="cp-meta-sep">·</span>
            <span className="cp-meta-item">
              Operated by <strong>D-Tech Studios</strong>
            </span>
          </div>

          {/* Cookie summary cards */}
          <div className="cp-summary-row">
            {[
              { icon: Ic.Lock,     color: '#10B981', bg: '#ECFDF5', title: 'Essential only',    body: '2 cookies required to keep you logged in and secure' },
              { icon: Ic.BarChart, color: '#3B82F6', bg: '#EFF6FF', title: 'Privacy-first analytics', body: 'Plausible Analytics no personal data, EU-hosted' },
              { icon: Ic.X,        color: '#EF4444', bg: '#FEF2F2', title: 'Zero ad cookies',   body: 'No Facebook, Google Ads, or retargeting of any kind' },
              { icon: Ic.Toggle,   color: '#8B5CF6', bg: '#F5F3FF', title: 'You are in control', body: 'Opt out of non-essential cookies any time from settings' },
            ].map((s, i) => (
              <div key={i} className="cp-summary-card" style={{ '--sc': s.color, '--sbg': s.bg }}>
                <div className="cp-summary-icon" style={{ background: s.bg, color: s.color }}>
                  <s.icon />
                </div>
                <div>
                  <p className="cp-summary-title">{s.title}</p>
                  <p className="cp-summary-body">{s.body}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Body ──────────────────────────────────────────── */}
      <div className="cp-body">
        <div className="cp-container cp-body-inner">

          {/* TOC sidebar */}
          <aside className="cp-toc">
            <p className="cp-toc-label">Contents</p>
            <nav className="cp-toc-nav">
              {SECTIONS.map(s => (
                <button
                  key={s.id}
                  className={`cp-toc-item${activeSection === s.id ? ' active' : ''}`}
                  style={{ '--tc': s.color }}
                  onClick={() => scrollTo(s.id)}
                >
                  <span className="cp-toc-dot" style={{ background: s.color }} />
                  <span className="cp-toc-text">{s.title}</span>
                  <Ic.ChevronRight className="cp-toc-arrow" />
                </button>
              ))}
            </nav>
            <div className="cp-toc-footer">
              <button className="cp-toc-btn" onClick={() => navigate('/PrivacyPolicy')}>
                <Ic.Shield /> Privacy Policy
              </button>
              <button className="cp-toc-btn" onClick={() => navigate('/Contact')}>
                <Ic.Mail /> Contact us
              </button>
            </div>
          </aside>

          {/* Content */}
          <main className="cp-content">
            {SECTIONS.map(section => (
              <section
                key={section.id}
                id={section.id}
                ref={el => (sectionRefs.current[section.id] = el)}
                className="cp-section"
              >
                <div className="cp-section-head">
                  <span className="cp-section-icon" style={{ background: `${section.color}14`, color: section.color }}>
                    <section.icon />
                  </span>
                  <h2 className="cp-section-title">{section.title}</h2>
                </div>

                {/* Interactive cookie table */}
                {section.isTable && <CookieTable />}

                {/* Prose content */}
                {!section.isTable && section.content?.map((block, i) => (
                  <div key={i} className="cp-block">
                    <h3 className="cp-block-title">{block.subtitle}</h3>
                    <div className="cp-block-body">
                      {block.body.split('\n\n').map((para, j) => (
                        <p
                          key={j}
                          className={
                            para.trim().startsWith('•') || para.includes('\n•')
                              ? 'cp-para cp-para--list'
                              : 'cp-para'
                          }
                        >
                          {para.split('\n').map((line, k, arr) => (
                            <span key={k}>
                              {line}
                              {k < arr.length - 1 && <br />}
                            </span>
                          ))}
                        </p>
                      ))}
                    </div>
                  </div>
                ))}
              </section>
            ))}

            {/* Footer note */}
            <div className="cp-footer-note">
              <Ic.Info className="cp-footer-icon" />
              <div>
                <p className="cp-footer-title">Questions about cookies?</p>
                <p className="cp-footer-body">
                  Read our full{' '}
                  <button className="cp-inline-link" onClick={() => navigate('/PrivacyPolicy')}>Privacy Policy</button>
                  {' '}for the complete picture of how we handle your data.{' '}
                  <button className="cp-inline-link" onClick={() => navigate('/Contact')}>Contact us</button>
                  {' '}at privacy@quickpdfs.net with any questions.
                </p>
              </div>
            </div>
          </main>
        </div>
      </div>

      {/* Back to top */}
      {showBackToTop && (
        <button
          className="cp-back-to-top"
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          aria-label="Back to top"
        >
          <Ic.ArrowUp />
        </button>
      )}
    </div>
  );
}